import React, { useState, useMemo } from "react";
import "@styles/pages/Login/Samsung/SamsungAccountLogin.scss";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams, useLocation } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { redirectToSamsungLoginPage } from "@utils/redirectToSamsungLoginPage";

const SamsungAccountLogin = () => {
  const [searchParams] = useSearchParams();
  const redirect_url = searchParams.get("redirect_url");
  const url = redirect_url || "/";

  const host = window.location.hostname;
  const index = useMemo(() => {
    if (host === "localhost") {
      return "LocalIndex";
    } else {
      return "Index";
    }
  }, []);

  const handleSamsungLogin = () => {
    redirectToSamsungLoginPage({ index, url: url });
  };
  return (
    <Box className="samsung-account-login-container">
      <Button
        onClick={handleSamsungLogin}
        className="button samsung-button"
        fullWidth
      >
        <Trans i18nKey="login:samsung_login" />
      </Button>
    </Box>
  );
};

export default SamsungAccountLogin;
